import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { api } from '@app/utils/api';
import { BI_BASE_URL } from '@app/contstants/endpoints';
import { ManagersResponse } from '../types';
import { QUERY_KEY_MANAGER_PERFORMANCE } from '../query-keys';

const getManagers = async (): Promise<ManagersResponse> => {
  const { data } = await api.get<ManagersResponse>(`${BI_BASE_URL}/helpers/managers`);

  return data;
};

export const useGetManagers = (): UseQueryResult<ManagersResponse, unknown> => {
  return useQuery({
    queryKey: [QUERY_KEY_MANAGER_PERFORMANCE.MANAGERS],
    queryFn: getManagers,
  });
};
